import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

export function getColumns(columnsConditions = {}) {
  const columns = prepareColumns(columnsConditions);

  return columns.filter((item) => {
    // eslint-disable-next-line no-prototype-builtins
    if (columnsConditions.hasOwnProperty(item.name)) {
      return columnsConditions[item.name];
    }
    return true;
  });
}

function prepareColumns(columnsConditions) {
  // if we're showing isNew column - width will be smaller and copyToClipboard column will take 2 last columns
  const addedAtWidth = columnsConditions.isNew ? 120 : 150;

  return [
    {
      name: 'status',
      title: '',
      width: 50,
    },
    {
      name: 'sector',
      title: 'Sector',
      sortable: true,
      className: alignStyles.alignLeft,
      width: 70,
    },
    {
      name: 'name',
      title: 'Bond',
      sortable: true,
      className: alignStyles.alignLeft,
      width: 140,
    },
    {
      name: 'originalFace',
      title: 'Orig Face',
      sortable: true,
      className: alignStyles.alignRight,
      width: 110,
      tooltipContent: 'Original Face',
    },
    {
      name: 'currentFace',
      title: 'Curr Face',
      sortable: true,
      className: alignStyles.alignRight,
      width: 110,
      tooltipContent: 'Current Face',
    },
    {
      name: 'wal',
      title: 'Wal',
      sortable: true,
      className: alignStyles.alignRight,
      tooltipContent: 'Weighted Average Life',
    },
    {
      name: 'ratingMoodys',
      title: 'MO',
      sortable: true,
      className: alignStyles.alignCenter,
      tooltipContent: 'Moody\'s Rating',
    },
    {
      name: 'ratingSAndP',
      title: 'SP',
      sortable: true,
      className: alignStyles.alignCenter,
      tooltipContent: 'S&P Rating',
    },
    {
      name: 'ratingFitch',
      title: 'FI',
      sortable: true,
      className: alignStyles.alignCenter,
      tooltipContent: 'Fitch Rating',
    },
    {
      name: 'ratingDbrs',
      title: 'DR',
      sortable: true,
      className: alignStyles.alignCenter,
      tooltipContent: 'Morningstar DBRS Rating',
    },
    {
      name: 'ratingKroll',
      title: 'KR',
      sortable: true,
      className: alignStyles.alignCenter,
      tooltipContent: 'Kroll Rating',
    },
    {
      name: 'ratingOtherOrUnspecified',
      title: 'OT',
      sortable: true,
      className: alignStyles.alignCenter,
      tooltipContent: 'Other / Unspecified Rating',
    },
    {
      name: 'spread',
      title: 'Spread',
      sortable: true,
      className: alignStyles.alignRight,
      width: 70,
    },
    {
      name: 'speed',
      title: 'Speed',
      sortable: true,
      className: alignStyles.alignRight,
      width: 70,
    },
    {
      name: 'ce',
      title: 'C/E',
      sortable: true,
      className: alignStyles.alignRight,
    },
    {
      name: 'price',
      title: 'Price',
      sortable: true,
      className: alignStyles.alignRight,
    },
    {
      name: 'dealer',
      title: 'Dealer',
      sortable: true,
      className: alignStyles.alignRight,
      tooltipContent: 'Broker-Dealer',
    },
    {
      name: 'aging',
      title: 'Aging',
      sortable: true,
      className: alignStyles.alignRight,
      tooltipContent: 'Days Live on CreditFlow B&I',
    },
    {
      name: 'addedAt',
      title: 'Date added',
      sortable: true,
      className: alignStyles.alignRight,
      width: addedAtWidth,
      minWidth: addedAtWidth,
    },
    {
      name: 'isNew',
      title: '',
      className: alignStyles.alignCenter,
      width: 60,
    },
  ];
}
